import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface CommonState {
  /**
   * ### 共通メッセージ
   * - 画面間でメッセージを受け渡す際に使用する
   */
  message: string;
  /**
   * ### 前画面URL
   * - トークン有効期限切れ等で再ログイン時はログイン後に元いたURLに戻るために使用する
   */
  beforeUrl: string;
  /**
   * ### 前回ログイン施設ID
   * - トークン有効期限切れ等で再ログイン時に別施設にログインする場合があるのでチェックのため保持する
   */
  beforeLoginFacilityId: number;
  /**
   * ### アプリモード
   * - PCかSPかを持つ
   */
  appmode: string;
}

/**
 * ### Common store
 *
 */
@Module({ name: "common" })
export default class Common extends VuexModule implements CommonState {
  message: string = "";
  beforeUrl: string = "";
  beforeLoginFacilityId = -1;
  appmode: string = "";

  /** ユーザーのgetters */
  get appMode(): string {
    return this.appmode;
  }

  @Mutation
  private SET_MESSAGE(message: string): void {
    this.message = message;
    return;
  }

  @Mutation
  private SET_BEFORE_URL(url: string): void {
    this.beforeUrl = url;
    return;
  }

  @Mutation
  private SET_LOGIN_FACILITY_ID(facilityId: number): void {
    this.beforeLoginFacilityId = facilityId;
    return;
  }

  @Mutation
  private SET_APPMODE(appmode: string): void {
    this.appmode = appmode;
    return;
  }

  /**
   * ### 共通メッセージを設定する
   *
   * - 共通メッセージを設定する
   * - { rawError: true }を設定しないと例外発生時に正しくエラーが上位に投げられない
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public setMessage(payload: { message: string }): void {
    this.SET_MESSAGE(payload.message);

    return;
  }

  /**
   * ### 前画面URLを設定する
   */
  @Action({ rawError: true })
  public setBeforeUrl(payload: { url: string }): void {
    this.SET_BEFORE_URL(payload.url);
    return;
  }

  /**
   * ### 前回ログイン施設IDを設定する
   */
  @Action({ rawError: true })
  public setBeforeLoginFacilityId(payload: { id: number }): void {
    this.SET_LOGIN_FACILITY_ID(payload.id);
    return;
  }

  /**
   * ### アプリモードを設定する
   */
  @Action({ rawError: true })
  public setAppmode(payload: { appmode: string }): void {
    this.SET_APPMODE(payload.appmode);
    return;
  }
}
